// RecordTypes.js
export class RecordTypes {
    static Primary = "Primary";
    static User = "User";
    static Note = "Note";
    static Session = "Session";
    static OverrideRealmObject = "OverrideRealmObject";
    static StoryItem = "StoryItem";
    static Character = "Character";
  }